import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function apiErr(e, fallback = "Une erreur est survenue.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

// Refresh-retry interceptor: on 401, try a single /auth/refresh then replay the request.
// If refresh fails, signal the app to return to login instead of throwing an uncaught error.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    const skip = ["/auth/refresh", "/auth/login", "/auth/logout", "/auth/register", "/auth/me"].some((p) => url.includes(p));
    if (status === 401 && !original._retry && !skip) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        if (typeof window !== "undefined") window.dispatchEvent(new Event("pc-unauthorized"));
        // Session is terminally invalid — the app redirects to Login. Return a
        // never-resolving promise so page-level loaders don't surface an uncaught 401.
        return new Promise(() => {});
      }
    }
    return Promise.reject(error);
  }
);

export default api;
